import FacialRoute from "./facial/facial.device.router";

export default [...FacialRoute];
